module.exports = __webpack_public_path__ + "82cfe0176da092588dd49afae939e5aa.svg";